export const environment = {
    baseUrl: "https://cf.cuanki.my.id",
    companyCode: "DEV1",
    api_key: "deg43sx4f4cs9fi4k"
};
